export default __webpack_public_path__ + "static/Effects-337aa31738e8ba58b41c9158a611042d.png";